import { Accordion, Card, CardGroup } from '@ps/isp-web-component-library';
import React from 'react';

import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/betSlip/types';

import { isSingleReceiptItems } from '../../../../../../utils/isReceiptItem';

import styles from './ReceiptItems.scss';
import ReceiptItem from './components/ReceiptItem/ReceiptItem';

interface Props {
  isOpen: boolean;
  title: React.ReactElement<{ isOpen: boolean }>;
  receiptItems: SingleReceiptItem[] | MultipleReceiptItem[];
  accessibilityLabel?: string;
}

const ReceiptItems: React.FC<Props> = ({ isOpen, title, receiptItems, accessibilityLabel }) => {
  if (!receiptItems.length) {
    return null;
  }

  let content = (
    <Card isPadded>
      {receiptItems.map((receiptItem) => (
        <ReceiptItem key={receiptItem.id} receiptItem={receiptItem} />
      ))}
    </Card>
  );

  if (isSingleReceiptItems(receiptItems)) {
    content = (
      <>
        {receiptItems.map((receiptItem) => (
          <ReceiptItem key={receiptItem.id} receiptItem={receiptItem} />
        ))}
      </>
    );
  }

  return (
    <div className={styles.accordionWrapper}>
      <Accordion
        isOpenInitially={isOpen}
        accessibilityLabel={accessibilityLabel}
        variant="quaternary"
      >
        <Accordion.Header>{title}</Accordion.Header>
        <Accordion.Body>
          <CardGroup isCondensed isPadded>
            {content}
          </CardGroup>
        </Accordion.Body>
      </Accordion>
    </div>
  );
};

export default ReceiptItems;
